<style>
    .my-drop-zone { border: dotted 3px lightgray; }
    .nv-file-over { border: dotted 3px red; }
    .another-file-over-class { border: dotted 3px green; }

    html, body { height: 100%; }
</style>

<c-card *transloco="let t">
    <c-card-body>

<div class="container">
    <c-row>
      <c-col md="8">
          <h1>{{ t('Import Alert Loops')}}</h1>
      </c-col>
      <c-col  md="4" class="text-end">
        <div class="btn-group mb-2 " role="group">
          <button color="light" cButton  routerLink="/mgmt/alertloops/alertloops">
            <svg cIcon class="me-2" name="cil-chevron-left"></svg>
            {{ t('Return to Alert Loops') }}
          </button>
          <button type="button" class="btn btn-light" (click)="reset()" *ngIf="step > 1"><i class="fa-solid fa-angles-left"></i> {{ t("Upload another File")}}</button>
          <a href="https://okalone.zendesk.com/hc/en-gb/articles/44590007047825-Uploading-Alert-Loops-to-OK-Alone" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
        </div>
        </c-col>
    </c-row>

    <div class="row"  *ngIf="step == 1">

        <div class="col-12 mb-3">
          <div class="alert alert-info" role="alert">
            <h5><i class="fa-solid fa-circle-info"></i> {{ t('How to Upload Alert Loops') }}</h5>
            <ol class="mb-1">
              <li>{{ t('Download the') }} <a href="/assets/files/AlertLoopsImport.xlsx" target="_new"><i class="fa-solid fa-file-excel"></i> {{ t('Alert Loops template file') }}</a> {{ t('or export your existing alert loops from the Alert Loops page.') }}</li>
              <li>{{ t('Fill in or edit the alert loop data in the spreadsheet. Do not change the column order.') }}</li>
              <li>{{ t('Each row is one alert loop. Columns E–J define the monitor contact sequence (up to 6 monitors per loop).') }}</li>
              <li>{{ t('Upload the file using the drop zone or file selector below.') }}</li>
              <li>{{ t('Review the parsed data and fix any errors before confirming the import.') }}</li>
            </ol>
            <p class="mb-0"><small><i class="fa-solid fa-triangle-exclamation"></i> {{ t('Alert loops with the same name as existing ones will be updated. New names will create new alert loops. Monitor names must match existing monitors exactly. Maximum 100 alert loops per file.') }}</small></p>
          </div>
        </div>

        <div class="col-md-4">

            <h3>{{ t('Select files') }}</h3>

            <div ng2FileDrop
                 [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
                 (fileOver)="fileOverBase($event)"
                 [uploader]="uploader"
                 class="well my-drop-zone"
                 style="width:100%;height:200px;">
                {{ t('Drop your alert loop upload file here or select it using the button below') }}
            </div>
            <input type="file" ng2FileSelect [uploader]="uploader" />
        </div>

        <div class="col-md-8" style="margin-bottom: 40px">

            <h3>{{ t('Upload queue') }}</h3>
            <p>{{ t('Queue length') }}: {{ uploader?.queue?.length }}</p>

            <table class="table">
                <thead>
                <tr>
                    <th width="50%">{{ t('Name') }}</th>
                    <th>{{ t('Size') }}</th>
                    <th>{{ t('Progress') }}</th>
                    <th>{{ t('Status') }}</th>
                    <th>{{ t('Actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of uploader.queue">
                    <td><strong>{{ item?.file?.name }}</strong></td>
                    <td *ngIf="uploader.options.isHTML5" nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }} MB</td>
                    <td *ngIf="uploader.options.isHTML5">
                        <div class="progress" style="margin-bottom: 0;">
                            <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': item.progress + '%' }"></div>
                        </div>
                    </td>
                    <td class="text-center">
                        <span *ngIf="item.isSuccess"><i class="glyphicon glyphicon-ok"></i></span>
                        <span *ngIf="item.isCancel"><i class="glyphicon glyphicon-ban-circle"></i></span>
                        <span *ngIf="item.isError"><i class="glyphicon glyphicon-remove"></i></span>
                    </td>
                    <td nowrap>
                        <button type="button" class="btn btn-success btn-xs"
                                (click)="item.upload()" [disabled]="item.isReady || item.isUploading || item.isSuccess">
                            <span class="glyphicon glyphicon-upload"></span> {{ t('Upload') }}
                        </button>
                        <button type="button" class="btn btn-warning btn-xs"
                                (click)="item.cancel()" [disabled]="!item.isUploading">
                            <span class="glyphicon glyphicon-ban-circle"></span> {{ t('Cancel') }}
                        </button>
                        <button type="button" class="btn btn-danger btn-xs"
                                (click)="item.remove()">
                            <span class="glyphicon glyphicon-trash"></span> {{ t('Remove') }}
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

            <div>
                <div>
                    {{ t('Queue progress') }}:
                    <div class="progress" style="">
                        <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
                    </div>
                </div>
                <div class="alert alert-danger" role="alert"  *ngIf="file_error">
                  {{file_error}}
                </div>
            </div>

        </div>

    </div>

    <br><br>

    <div class="row" *ngIf="step == 2">
        <div class="col-md-12">

            <p>{{ t('We have processed the alert loop upload file. Please check the following data. Only alert loops with no errors will be imported or updated.') }}</p>


            <div class="alert alert-danger" role="alert"  *ngIf="upload_errors">
              <b>{{ t('Upload Issue') }}</b> {{ t('We have detected some issues with your upload file. Please check them in the table below, fix them in the file and resubmit the file.') }}
            </div>

            <c-row>
                <c-col class="text-center">
                  <button type="button" class="btn btn-primary" (click)="uploadAlertLoops()"  *ngIf="!upload_errors"><i class="fa-solid fa-file-import"></i> {{ t('Import these Alert Loops') }}</button>
                  <button type="button" class="btn btn-outline-primary" (click)="reset()"  *ngIf="upload_errors"><i class="fa-solid fa-angles-left"></i> {{ t('Upload Another File') }}</button> <br/><br/>
                </c-col>
            </c-row>


            <c-row>
                <c-col>

                  <table
                  [hover]="true"
                  [responsive]="true"
                  [striped]="true"
                  align="middle"
                  cTable
                  class="mb-0 border"
                  >
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ t('Name') }}</th>
                        <th scope="col">{{ t('Repeat') }}</th>
                        <th scope="col">{{ t('Loop Wait') }}</th>
                        <th scope="col">{{ t('Step Wait') }}</th>
                        <th scope="col">{{ t('Monitor Steps') }}</th>
                        <th scope="col"></th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let alertloop of alertloops" [class.table-success]="!alertloop.alertloop_id && alertloop.errors.length==0">
                          <td>
                            <h4>
                                <span class="badge bg-secondary" *ngIf="alertloop.alertloop_id"><i class="fa-solid fa-check"></i> {{ t('Already Exists') }}</span>
                                <span class="badge bg-primary" *ngIf="!alertloop.alertloop_id && alertloop.errors.length==0"><i class="fa-solid fa-file-import"></i> {{ t('Ready to Import') }}</span>
                                <span class="badge bg-danger" *ngIf="alertloop.errors.length!=0"><i class="fa-solid fa-circle-xmark"></i> {{ t('Data Error') }}</span>
                            </h4>
                          </td>
                          <td>
                            <span><b>{{alertloop.name}}</b></span>
                          </td>
                          <td>
                            {{alertloop.loop_count}}
                          </td>
                          <td>
                              {{alertloop.loop_wait}} {{ t('mins') }}
                          </td>
                          <td>
                              {{alertloop.step_wait}} {{ t('mins') }}
                          </td>
                          <td>
                              <span *ngFor="let step of alertloop.steps" class="badge bg-info m-1">
                                <i class="fa-solid fa-user"></i> {{step.name}}
                              </span>
                              <span *ngIf="alertloop.steps.length == 0" class="text-muted">{{ t('No monitors') }}</span>
                          </td>
                          <td>
                              <ul *ngIf="alertloop.errors.length > 0" class="text-danger">
                                  <li *ngFor="let error of alertloop.errors">{{error}}</li>
                              </ul>
                          </td>
                        </tr>
                      </tbody>

                  </table>

                </c-col>
              </c-row>
        </div>
    </div>


    <div class="row" *ngIf="step == 3">
        <div class="col-md-12">

            <p>{{ t('The following alert loops have now been imported or updated:') }}</p>

            <c-row>
                <c-col>

                  <table
                  [hover]="true"
                  [responsive]="true"
                  [striped]="true"
                  align="middle"
                  cTable
                  class="mb-0 border"
                  >
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ t('Alert Loop Name') }}</th>
                        <th scope="col">{{ t('Repeat') }}</th>
                        <th scope="col">{{ t('Loop Wait') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let alertloop of alertloops2">
                          <td>
                            <h4>
                                <span class="badge bg-success"><i class="fa-solid fa-check"></i> {{ t('Imported') }}</span>
                            </h4>
                          </td>
                          <td>
                            <span><b>{{alertloop.name}}</b></span>
                          </td>
                          <td>
                            {{alertloop.loop_count}}
                          </td>
                          <td>
                            {{alertloop.loop_wait}} {{ t('mins') }}
                          </td>
                        </tr>
                      </tbody>

                  </table>

                </c-col>
              </c-row>
        </div>
    </div>

</div>


</c-card-body>
</c-card>
